
import { Component, Vue } from 'vue-property-decorator';

import { OrderCheckStage } from '@/types/orderCheck';

import OrderList from './components/OrderList.vue';
import OrderSearch from './components/OrderSearch.vue';

@Component({
  name: 'OrderCompleted',
  components: {
    OrderList,
    OrderSearch
  }
})
export default class extends Vue {
  private stage = OrderCheckStage.CLOSE;
}
